angular.module('leanlaw').controller('ContingencyReportDetailCtrl', ['$scope', '$window', '$q', '$rootScope', '$timeout', '$filter', '$stateParams', '$state', "alerts", 'userService', 'clientMatterManager', 'reportsService', 'accountingService', "exportJson", "singleRequest", "leanLawApi", "messageBus", function ($scope, $window, $q, $rootScope, $timeout, $filter, $stateParams, $state, alerts, userService, clientMatterManager, reportsService, accountingService, exportJson, singleRequest, leanLawApi, messageBus) {
  $scope.clients = {};
  $scope.filter = {};
  $scope.loading = true;
  $scope.withHeaders = false;
  $scope.search = "";
  $scope.format = {};
  $scope.sort = 'date';
  $scope.reverse = false;
  $scope.doneLoading = false;
  $scope.data = {};
  $scope.print = function (withHeaders) {
    $scope.withHeaders = withHeaders;
    waitForDomThenPrint();
  };
  function waitForDomThenPrint() {
    $scope.printing = true;
    $scope.doneLoading = true;
    $timeout(() => {
      var element = $window.document.getElementById('done-loading');
      console.log('VALUE', element && element.innerHTML);
      if (element && element.innerHTML == 'true') {
        $window.print();
        $scope.doneLoading = false;
        $scope.printing = false;
        $scope.withHeaders = false;
      } else {
        waitForDomThenPrint();
      }
    }, 200);
  }
  async function loadClientMatter(clientId, matterId) {
    let status = {};
    try {
      status = await accountingService.verify(false);
    } catch (e) {
      //
    }
    let cm = {};
    let billing = null;
    if (matterId) {
      billing = await leanLawApi.getMatterBilling({
        id: matterId
      });
      cm.matter = await clientMatterManager.getMatter(matterId);
      cm.client = cm.matter.client;
      if (cm.matter.billing.contingency && cm.matter.billing.contingency.noExpenseInterest) {
        $scope.expenseInterest = 0;
      }
    } else {
      billing = await leanLawApi.getClientBilling({
        id: clientId
      });
      cm.client = await clientMatterManager.getClient(clientId, {
        matters: 'include'
      });
    }
    var address = billing.address.formatted.split("\n");
    $scope.address = {
      firm: status.companyName && `
                        <p><b>${status.companyName}</b><br/>
                        ${(status.companyAddress || '').replace(/\n/g, '<br/>')}
                        </p>`,
      client: `
                        <p>
                        <b>${address[0]}</b></br>
                        ${address.slice(1).join('<br/>')}
                        </p>
                        <p></p>`,
      matter: matterId && `<p>Re: ${cm.matter.label}</p>`
    };
    $scope.cm = cm;
    messageBus.addMessage("clientmatter-set", true, cm);
  }
  $scope.export = function () {
    let exp = $scope.data.expenses.map(e => {
      var line = {
        "Date": e.date,
        "Description": e.description,
        "Amount": e.amount
      };
      if ($scope.expenseInterest) {
        line["Interest"] = e.interest;
      }
      return line;
    });
    exportJson.downloadCsv(exp);
  };
  userService.me().then(me => {
    $scope.expenseInterest = me.company.settings.fees && me.company.settings.fees.expenseInterest;
    loadClientMatter($stateParams.clientId, $stateParams.matterId).then(() => {
      $scope.$on('commonFilterService-statechanged', (event, payload) => {
        if (!payload) return;
        // Assigning to existing filter keeps custom filter options
        $scope.filter = Object.assign($scope.filter, payload);
        // Necessary to set this value for the requests
        $scope.filter.billedFilter = $scope.filter.contingencyBilledFilter;
        $scope.filter.status = $scope.filter.archived.status;
        $scope.filter.scope = $scope.filter.filter.scope;
        filterClientEntries();
      });
      $scope.$on("report-sidebar-filterchange", (event, payload) => {
        $scope.filter = Object.assign($scope.filter, payload);
      });
      $scope.$on("report-clientmatter-change", async (event, cm) => {
        if (!cm.client && !cm.matter) {
          return $state.go("reports.contingency");
        }
        $scope.loading = true;
        await loadClientMatter(cm.client ? cm.client.id : null, cm.matter ? cm.matter.id : null);
        filterClientEntries();
      });

      // MessageBus is used here so that the commonFilter module can pick it up once it loads
      messageBus.addMessage("filterDependency-ready", true);
    });
  });
  function filterClientEntries() {
    $scope.loading = true;
    $scope.endDate = $scope.filter.range.endDate || new Date();
    $scope.endDate = new Date($scope.endDate.getFullYear(), $scope.endDate.getMonth(), $scope.endDate.getDate());
    var query = reportsService.queryFromFilter($scope.filter);
    if ($scope.cm.matter) {
      query.matterId = $scope.cm.matter.id;
    } else {
      query.clientId = $scope.cm.client.id;
    }
    query.scope = null;
    query.scopeAccount = null;
    query.billingType = "contingency";
    singleRequest.apiCall("expenses").listExpenses(query).then(list => {
      if (!list) return;
      $scope.data.expenses = list.expenses;
      $scope.data.total = list.expenses.reduce((sum, e) => sum + e.amount, 0);
      if ($scope.expenseInterest) {
        let total = 0;
        $scope.data.expenses.forEach(e => {
          if (includeInterest(e)) {
            e.interest = interest(e);
            total += e.interest;
          }
        });
        $scope.data.interest = {
          date: $scope.filter.range.endDate || new Date(),
          total
        };
      }
      $scope.loading = false;
    }).catch(err => {
      $scope.loading = false;
      alerts.error(err);
    });
  }
  const deactivate = $rootScope.$on('$stateChangeStart', () => {
    singleRequest.cancel("expenses");
    deactivate();
  });
  function interest(e) {
    const MILLISECONDS_PER_DAY = 1000 * 60 * 60 * 24;
    const timeDiff = Math.abs(new Date(e.date).getTime() - $scope.endDate.getTime());
    const totalDays = Math.ceil(timeDiff / MILLISECONDS_PER_DAY);
    const interestAmount = e.amount * totalDays * $scope.expenseInterest / (365 * 100);
    return parseFloat(interestAmount.toFixed(2));
  }
  function includeInterest(e) {
    var matter = $scope.cm.matter || $scope.cm.client.matters.find(m => e.matter.id == m.id);
    return matter.billing.contingency ? matter.billing.contingency.noExpenseInterest != true : true;
  }

  // The rows the table shows. Precomputed here rather than sorted from the
  // ng-repeat expression, which re-ran the sort on every digest.
  function updateFiltered() {
    if (!$scope.data) return;
    $scope.data.filteredExpenses = $filter('orderBy')($scope.data.expenses, $scope.sort, $scope.reverse) || [];
  }
  $scope.$watch('data.expenses', updateFiltered);
  $scope.$watchGroup(['sort', 'reverse'], updateFiltered);
}]);